export enum Debtor {
  PRIMARY = 'primary',
  SECONDARY = 'secondary'
}

export enum CheckIconsStates {
  CHECKED,
  UNCHECKED
}
